
import { ShieldAlert } from 'lucide-react';
import { confirmDialog } from '@/shared/ui';

export function linkHost(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
}

function readable(url: string): string {
  try {
    return decodeURI(url);
  } catch {
    return url;
  }
}

export async function openExternalLink(url: string): Promise<void> {
  const ok = await confirmDialog({
    title: 'Ссылка ведёт на другой сайт',
    description: `Вы уходите с портала на ${linkHost(url)}. Ссылку прислали в переписке — убедитесь, что сайт вам знаком, и не вводите на нём пароль от портала.`,
    code: readable(url),
    Icon: ShieldAlert,
    tone: 'danger',
    confirmLabel: 'Перейти',
    cancelLabel: 'Остаться',
  });
  if (!ok) return;
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function onExternalLinkClick(
  url: string,
): (e: React.MouseEvent<HTMLAnchorElement>) => void {
  return (e) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    e.stopPropagation();
    void openExternalLink(url);
  };
}
